<template lang="pug">
    v-container.containerWrap
        v-layout(row wrap)
            v-flex.wrapperOuter(xs12)
                div.wrapper

                    div(v-if="!isMobile" )
                        // Ocean
                        ocean.z-1(:mood="mood")

                        // Sun
                        sun.z-2(:mood="mood")

                        // Cloud
                        cloud.z-3(:mood="mood")

                        // Lightning
                        lighting.z-4(:mood="mood")

                        // Background overlay
                        overlay.z-5(:mood="mood")

                    div.mood.z-6(:class="moodStylesClass")
                        div.moodTitle How are you currently feeling?
                        div.moodControls()

                            div.moodControlsRow( v-for="chunk in moodButtons" )
                                a.moodAction(
                                    v-for="moodButton in chunk"
                                    :key="`${moodButton.value}-mood-button`"
                                    href="#"
                                    :class="{'isActiveMood': moodButton.value === mood}"
                                    @click.prevent="() => handleSetMood(moodButton)"
                                )
                                    <component :is="moodButton.icon" :color="moodButton.value === mood ? '#ffffff' : '#022341'"/>
                                    div.mt-1 {{ moodButton.label }}

                        div.moodActions
                            button-component.setMoodButton.mx-0(
                                dark
                                primary
                                large
                                fullWidth
                                :disabled="mood === 51"
                                color="primary"
                                :action="saveMood"
                                ) Set your Mood
</template>

<script>
    import Cloud from './Cloud/Cloud';
    import Overlay from './Overlay/Overlay';
    import Sun from './Sun/Sun';
    import Lighting from './Lightning/Lightning';
    import Ocean from './Ocean/Ocean';
    import AnxiousIcon from './icons/anxious.vue';
    import ChillIcon from './icons/chill.vue';
    import ContentIcon from './icons/content.vue';
    import InBetweenIcon from './icons/in-between.vue';
    import StressedIcon from './icons/stressed.vue';
    import Button from '~components/Button';
    import { mapActions, mapGetters } from 'vuex';
    import VueTypes from "vue-types";

    export default {
        components: {
            Cloud,
            Overlay,
            Sun,
            Lighting,
            Ocean,
            AnxiousIcon,
            ChillIcon,
            ContentIcon,
            InBetweenIcon,
            StressedIcon,
            ButtonComponent: Button
        },
        props: {
            launchCallback: VueTypes.func.def(() => {})
        },
        data() {
            return {
                mood: 51,
                moodStylesClass: 'moodDefault',
                moodButtons: [
                    [
                        {
                            value: 1,
                            icon: 'stressedIcon',
                            label: 'stressed',
                            stylesClass: 'moodStressed'
                        },
                        {
                            value: 25,
                            icon: 'AnxiousIcon',
                            label: 'anxious',
                            stylesClass: 'moodAnxious'
                        },
                        {
                            value: 50,
                            icon: 'InBetweenIcon',
                            label: 'in between',
                            stylesClass: 'moodInBetween'
                        }
                    ],
                    [
                        {
                            value: 75,
                            icon: 'ContentIcon',
                            label: 'content',
                            stylesClass: 'moodContent'
                        },
                        {
                            value: 100,
                            icon: 'ChillIcon',
                            label: 'chill',
                            stylesClass: 'moodChill'
                        }
                    ]
                ]
            };
        },
        computed: {
            ...mapGetters('sessions', ['moodBefore', 'showMood']),
            /**
             * Check screen resolution
             */
            isMobile() {
                return this.$vuetify.breakpoint.smAndDown;
            }
        },
        methods: {
            ...mapActions('sessions', ['setMood', 'skipMood']),
            saveMood() {
                this.setMood(this.mood);
                !this.moodBefore && this.launchCallback();
            },
            handleSetMood(moodButton) {
                this.mood = moodButton.value;
                this.moodStylesClass = moodButton.stylesClass;
            }
        }
    };
</script>

<style scoped lang="stylus">
    @import "../../assets/style/_variables.styl";
    @import "../../assets/style/_mixins.styl"

    .containerWrap
        height: auto
        display: flex
        align-items: center
        justify-content: center

    .wrapper
        width: 80%
        margin-left: 10%
        position: relative
        z-index: 1
        overflow: hidden
        border-radius: 10px

    .moodAction
        margin: 6px
        padding: 8px 6px
        background: rgba(255, 255, 255, 0.6);
        box-shadow: 0 8px 20px rgba(144, 173, 214, 0.2);
        border-radius: 10px;
        display: flex
        flex-direction: column
        align-items: center
        color: $theme.primary
        text-decoration: none
        white-space: nowrap
        width: 84px
        font-weight: 400
        font-size: 13px

        &.isActiveMood
            background-color: $theme.action
            color: $theme.white

    .moodTitle
        margin-bottom: 4vw
        font-size: 28px
        font-weight: 500
        color: $theme.black
        font-style: italic
        text-align: center

    .moodControls
    .moodControlsRow
        display: flex
        align-items: center
        justify-content: center

    .moodControls
        flex-direction: row
        position: relative
        z-index: 10

    .mood
        padding: 40px
        display: flex
        align-items: center
        justify-content: center
        flex-direction: column
        background: rgba($theme.primary, 0.15)
        background-size: cover
        background-position: 50% 50%
        transition: background-image 0.4s ease-in-out
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%

    .moodActions
        margin-top: 4vw

    .moodActions
        width: 50%

    .setMoodButton
        width: 100%

    @media screen and (max-width: $grid-breakpoints.md - 1)
        .moodControls
            flex-direction: column

        .moodActions
            width: 100%
            max-width: 440px

        .containerWrap,
        .wrapper
            width: 100vw
            height: 100vh
            margin: 0
            position: fixed
            top: 0
            left: 0

        .moodAction
            margin: 8px
            padding: 15px 12px

        .moodActions
            margin-top: 40px

        .moodTitle
            margin-bottom: 40px

        .mood
            width: 100vw
            height: 100vh
            transition: background-image 0.4s ease-in-out
            background-image: url("https://s3.us-east-2.amazonaws.com/chillanywhere.com/mood/default-mood.jpg")

            &:after
                position:absolute; width:0; height:0; overflow:hidden; z-index:-1; // hide images
                content:url("https://s3.us-east-2.amazonaws.com/chillanywhere.com/mood/stressed-min.jpg") url('https://s3.us-east-2.amazonaws.com/chillanywhere.com/mood/anxious-min.jpg') url('https://s3.us-east-2.amazonaws.com/chillanywhere.com/mood/in-between-min.jpg') url('https://s3.us-east-2.amazonaws.com/chillanywhere.com/mood/content-min.jpg') url('https://s3.us-east-2.amazonaws.com/chillanywhere.com/mood/completely-chill-min.jpg')

            &.moodStressed
                background-image: url("https://s3.us-east-2.amazonaws.com/chillanywhere.com/mood/stressed-min.jpg")

            &.moodAnxious
                background-image: url('https://s3.us-east-2.amazonaws.com/chillanywhere.com/mood/anxious-min.jpg')

            &.moodInBetween
                background-image: url('https://s3.us-east-2.amazonaws.com/chillanywhere.com/mood/in-between-min.jpg')

            &.moodContent
                background-image: url('https://s3.us-east-2.amazonaws.com/chillanywhere.com/mood/content-min.jpg')

            &.moodChill
                background-image: url('https://s3.us-east-2.amazonaws.com/chillanywhere.com/mood/completely-chill-min.jpg')
</style>
